import { render, staticRenderFns } from "./ReceptionPlant.vue?vue&type=template&id=2a1afd6a"
import script from "./ReceptionPlant.vue?vue&type=script&lang=js"
export * from "./ReceptionPlant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports